import { Profiles } from './profiles';
import { User } from './user';
import { Profile } from './profile';
import { EnumMicroDroits, MicroDroits } from './micro.droits';

export class RedirectionContext {

    /**
     * The redirected user
     */
    private readonly user: RedirectionContextUser;

    /**
     * The SIRET code of the organisation the user belongs to
     */
    private readonly siret: string;

    /**
     * The service the user belong to in the organisation
     */
    private readonly service: string;

    /**
     * The business payload of the redirection context
     */
    public readonly payload: any;

    /**
     * The list of micro-rights the user has for this organisation and service
     */
    private readonly profiles: Array<EnumMicroDroits>;

    public toProfiles(): Profiles {
        const profiles: Profiles = new Profiles();
        profiles.prenom = this.user?.firstName;
        profiles.nom = this.user?.lastName;
        profiles.mail = this.user?.email;

        profiles.profiles = [this.toProfile()];

        return profiles;
    }

    public toProfile(): Profile {
        const user = new User();
        user.siret = this.siret;
        user.service = this.service;
        user.raisonSociale = "";

        const microDroits = new MicroDroits();
        microDroits.microDroits = this.profiles;

        const profile: Profile = new Profile();
        profile.user = user;
        profile.microDroits = microDroits;
        return profile;
    }
}

export class RedirectionContextUser {
    public readonly firstName: string;
    public readonly lastName: string;
    public readonly email: string;
}
